// extracted by mini-css-extract-plugin
export default {"view-modal-content":"view-modal_view-modal-content__v4rrk","view-modal-body":"view-modal_view-modal-body__UiDPn"};